import {b as b$1}from'./chunk-BQVQIIVZ.js';import {a}from'./chunk-FXGGYGMU.js';import {b}from'./chunk-BVQ42ESU.js';import {GooglePay,AdyenCheckout,Dropin}from'@adyen/adyen-web/auto';import'@adyen/adyen-web/styles/adyen.css';import {useState,useRef,useMemo,useCallback,useImperativeHandle,useEffect}from'react';import De from'styled-components';import {defineMessages,useLocales}from'@sevenrooms/locales';import {useController}from'@sevenrooms/form';import {useTheme}from'@sevenrooms/ui-kit';import {jsx}from'react/jsx-runtime';import {RTKUtils,srGet,throwFetchError,srPostJson}from'@sevenrooms/api';import ue from'camelcase-keys';import {removeBeforeUnloadListener}from'@sevenrooms/ui-kit/hooks';var $=defineMessages({paymentDetailsOnSubmit:{id:"adyen.checkout.paymentDetailsOnSubmit",defaultMessage:"Payment details will be collected after clicking Submit."},problemWithCard:{id:"adyen.checkout.problemWithCard",defaultMessage:"Checkout failed. Please try another card."},cardSaveDisclaimer:{id:"adyen.checkout.cardSaveDisclaimer",defaultMessage:"By providing your card information, you allow {venueName} to charge your card for future payments in accordance with their terms."}});var z={ca:"ca-ES",da:"da-DK",de:"de-DE",en:"en-US",es:"es-ES",et:"et-EE",fr:"fr-FR",hu:"hu-HU",is:"is-IS",it:"it-IT",ja:"ja-JP",nl:"nl-NL",pt:"pt-PT",sv:"sv-SE",zh_CN:"zh-CN",nb:"en-US",th:"en-US",tr:"en-US",zh_HK:"en-US",lang:"en-US"},G=e=>z[e]||z.en;var[ce,U]=b();function Fe({paymentSettings:e,children:o,countryCode:n,currencyCode:_}){let[g,T]=useState(undefined),[p,c]=useState(),[y,b]=useState(),[A,h]=useState(false),[u,C]=useState(""),F=useRef(null),[f,l]=useState(),[v,i]=useState(),[r,D]=useState(),[I,R]=useState(),[w,P]=useState(),[m,k]=useState(),L=useMemo(()=>e.isProd?true:typeof window.Cypress>"u",[e.isProd]),s=G(e.selectedLanguage);return jsx(ce,{value:{paymentType:g,locale:s,setPaymentType:T,paymentData:p,setPaymentData:c,paymentAdditionalData:y,setPaymentAdditionalData:b,isValid:A,setIsValid:h,actualToken:u,setActualToken:C,adyenRef:F,adyenSDK:f,setAdyenSDK:l,dropIn:v,setDropIn:i,paymentResult:r,setPaymentResult:D,actions:I,setActions:R,countryCode:n,currencyCode:_,paymentError:w,setPaymentError:P,pendingReservationContext:m,setPendingReservationContext:k,redirectFromTopWhenInIframe:L,paymentAccountId:e?.paymentAccountId},children:o})}async function Q({venueId:e}){let o=`/api-yoa/adyen/${e}/get_initial_data`,{data:n}=await srGet(o).then(throwFetchError);return ue(n,{deep:true})}async function J({venueId:e,paymentData:o,pendingReservationContext:n}){let _=`/api-yoa/adyen/${e}/post_payment_details`,{data:g}=await srPostJson(_,{payment_details:o,actual_id:n.actualId,booking_from:n.bookingFrom,history_id:n.historyId}).then(throwFetchError);return g}var{useGetInitialDataQuery:Y,usePostPaymentDetailsMutation:Z}=a.enhanceEndpoints({addTagTypes:["PaymentsAdyenAPI"]}).injectEndpoints({endpoints:e=>({getInitialData:e.query({providesTags:["PaymentsAdyenAPI"],queryFn:RTKUtils.rtkQuery(Q)}),postPaymentDetails:e.mutation({queryFn:RTKUtils.rtkQuery(J)})})});var Ae="%{linkText}";function dt(){let{venueId:e,venueName:o,amount:n,isPaymentSectionValidField:_,setIsSubmitting:g}=b$1(),{formatMessage:T}=useLocales(),p=useRef(n),{field:{ref:c,onChange:y}}=useController(_),b=useCallback(H=>y(H),[y]),[A,h]=useState(false),[u,C]=useState(n),[F,f]=useState(false),{data:l}=Y({venueId:e}),v=useTheme(),{adyenRef:i,setAdyenSDK:r,setIsValid:D,setPaymentData:I,paymentType:R,setPaymentType:w,locale:P,dropIn:m,setDropIn:k,setActions:L,countryCode:s,currencyCode:a,setPaymentError:S,setPaymentAdditionalData:N,redirectFromTopWhenInIframe:W,paymentAccountId:ne}=U(),oe=window.top!==window.self;return useImperativeHandle(c,()=>({blur:()=>{},focus:()=>{i?.current?.scrollIntoView({behavior:"smooth",block:"center"});},reset:()=>{}}),[i]),useEffect(()=>{p.current=n;},[n]),useEffect(()=>{if(!l)return;if(m){let t=m?.props?.paymentMethodsConfiguration?.googlepay?.amount?.value,x=n*100;if(R==="googlepay"&&(t!==x||n!==u))m?.unmount(),C(n),h(false);else return}let H={base:{font:v?.textStyles?.body1,fontWeight:"normal"}},K=l.paymentMethods.message;oe&&(K={...K,paymentMethods:K.paymentMethods?.filter(t=>t.type!=="ideal")});let ae={paymentMethodsResponse:K,clientKey:l.clientKey,locale:P,environment:l.environment,showPayButton:false,countryCode:s.toUpperCase(),redirectFromTopWhenInIframe:W,onChange(t){D(t?.isValid),b(t?.isValid);},onSubmit(t,x,E){L(E),I(t);},onError(t){if(t?.message?.startsWith("AbortError")){g(false);return}S(t);},onActionHandled(t){t.componentType==="3DS2Challenge"&&i?.current?.scrollIntoView({behavior:"smooth",block:"center"});},onAdditionalDetails(t){N(t.data);}},re={paymentMethodsConfiguration:{googlepay:{amount:{value:n*100,currency:a},configuration:{merchantName:o,gatewayMerchantId:ne||""}},applepay:{amount:{value:n*100,currency:a}},card:{styles:H,hasHolderName:true,positionHolderNameOnTop:true,holderNameRequired:true,...n===0&&{disclaimerMessage:{message:T($.cardSaveDisclaimer,{venueName:o})+Ae,linkText:"",link:"https://sevenrooms.com/terms-of-service/"}}},bcmc:{styles:H}},onSelect:t=>{let x=t.props.type,E;t instanceof GooglePay?(E=!!t?.isReadyToPay,f(p?.current?p.current!==u:false)):(E=t.isValid,f(false)),w(x),D(E),b(E);},showPayButton:false};AdyenCheckout(ae).then(t=>{if(!i.current)return;m&&m?.unmount();let x=new Dropin(t,re).mount(i.current);k(x),A?t.update({locale:P}):h(true),r(t);});},[l,i,P,r,D,I,R,w,n,p,F]),jsx(Ce,{ref:i,"data-test":"adyen-checkout"})}var Ce=De.div`
  .adyen-checkout__dropin,
  .adyen-checkout__field--expiryDate,
  .adyen-checkout__field__cvc,
  .adyen-checkout__card__holderName,
  .adyen-checkout__dropdown__element {
    font: ${e=>e.theme.textStyles.body1};
    color: ${e=>e.theme.colors.primaryFont};
  }

  .adyen-checkout__input,
  .adyen-checkout__card__cardNumber__input,
  .adyen-checkout__card__cardNumber__input:hover,
  .adyen-checkout__card__cardNumber__input:focus,
  .adyen-checkout__card__cardNumber__input:active,
  .adyen-checkout__card__cardNumber__input:active:hover {
    border: none !important;
  }

  .adyen-checkout__dropdown__button,
  .adyen-checkout__input {
    color: ${e=>e.theme.colors.primaryFont};
    font: ${e=>e.theme.textStyles.body1};
    caret-color: ${e=>e.theme.colors.primaryFont};
    padding: ${e=>e.theme.spacing.sm} ${e=>e.theme.spacing.m};
    height: ${e=>e.theme.fieldHeight.m};
  }

  .adyen-checkout__dropdown__button--active,
  .adyen-checkout__dropdown__button--active:hover,
  .adyen-checkout__dropdown__button:active,
  .adyen-checkout__dropdown__button:focus,
  .adyen-checkout__dropdown__button:hover,
  .adyen-checkout__payment-method--selected .adyen-checkout__payment-method__image__wrapper {
    border: 1px solid ${e=>e.theme.colors.borderFocus} !important;
    box-shadow: none;
  }

  .adyen-checkout__payment-method--selected .adyen-checkout__payment-method__image__wrapper {
    transform: scale(1.2);
  }

  .adyen-checkout__dropdown__button,
  .adyen-checkout__input {
    border-radius: ${e=>e.theme.borderRadius.s};
  }

  .adyen-checkout__dropdown__button,
  .adyen-checkout__input,
  .adyen-checkout__dropdown__button--valid,
  .adyen-checkout__input--valid {
    border-color: ${e=>e.theme.colors.borders};
  }

  .adyen-checkout__input--error {
    border-color: ${e=>e.theme.colors.error};
  }

  .adyen-checkout__payment-methods-list {
    gap: 0;
  }

  .adyen-checkout__payment-method__image__wrapper {
    border: 1px solid ${e=>e.theme.colors.borders};
  }

  .adyen-checkout__payment-method {
    padding-left: ${e=>e.theme.spacing.s};
    padding-right: ${e=>e.theme.spacing.s};
  }

  .adyen-checkout__payment-method {
    border: none;
  }

  .adyen-checkout__payment-method--selected,
  .adyen-checkout__payment-method__details__content {
    margin: ${e=>e.theme.spacing.none};
    background: ${e=>e.theme.colors.infoBackground};
  }

  .adyen-checkout__payment-method:first-child {
    border-radius: ${e=>e.theme.borderRadius.none};
  }

  .adyen-checkout__payment-method:not(:first-child) {
    border-top: ${e=>`${e.theme.borderWidth.s} solid ${e.theme.colors.borders}`};
    border-radius: ${e=>e.theme.borderRadius.none};
  }

  .adyen-checkout__label__text,
  .adyen-checkout__fieldset__title,
  .adyen-checkout__label--focused,
  .adyen-checkout-form-instruction {
    font: ${e=>e.theme.textStyles.body1};
    color: ${e=>e.theme.colors.primaryFont};
    margin-bottom: ${e=>e.theme.spacing.s};
    text-transform: capitalize;
    padding: initial;
  }

  .adyen-checkout__fieldset__title {
    font: ${e=>e.theme.textStyles.h3};
    margin-bottom: ${e=>e.theme.spacing.m};
    letter-spacing: initial;
  }

  .adyen-checkout__payment-method__name {
    font: ${e=>e.theme.textStyles.body1};
  }

  .adyen-checkout__payment-method__name--selected {
    font: ${e=>e.theme.textStyles.body1bold};
  }

  .adyen-checkout-contextual-text--error {
    font: ${e=>e.theme.textStyles.error};
    margin-top: ${e=>e.theme.spacing.s};
  }

  .adyen-checkout-form-instruction {
    color: ${e=>e.theme.colors.secondaryFont};
    margin-bottom: ${e=>e.theme.spacing.m};
  }

  // requirement from the design team to hide form instructions and validation icons
  .adyen-checkout-form-instruction,
  .adyen-checkout-input__inline-validation {
    display: none;
  }

  .adyen-checkout__dropdown__button--valid {
    border-bottom-color: ${e=>e.theme.colors.borders};
  }

  .adyen-checkout__input::placeholder {
    font: ${e=>e.theme.textStyles.body1};
  }

  .adyen-checkout__card__cardNumber__input {
    border: none;
  }

  fieldset {
    padding: ${e=>e.theme.spacing.none};
  }

  .adyen-checkout__dropdown__element,
  .adyen-checkout__filter-input {
    text-transform: capitalize;
  }
`;function _t({venueId:e}){let{actions:o,paymentData:n,setPaymentData:_,setPendingReservationContext:g,adyenSDK:T,adyenRef:p,dropIn:c,paymentError:y,paymentAdditionalData:b,pendingReservationContext:A,paymentType:h}=U(),{formatMessage:u}=useLocales(),[C,F]=useState(),[f,l]=useState(),[v,i]=useState(),[r,D]=useState(),[I,R]=useState(false),[w,P]=useState(false),[m]=Z(),k=useCallback(s=>{o?.resolve({resultCode:"Authorised"}),v?.(s);},[v,o]),L=useCallback(async s=>{if(c)try{let a=await m({venueId:e,paymentData:s,pendingReservationContext:A}).unwrap();a.resultCode==="Authorised"?(c.setStatus("success",{message:"Payment successful!"}),k({token:a?.token})):(o?.reject({}),r?.({errors:[u($.problemWithCard)]}));}catch{o?.reject({}),r?.({errors:[u($.problemWithCard)]});}},[o,m,c,u,k,r,A,e]);if(b&&c&&!w&&(P(true),L(b)),y&&r&&r({errors:[y]}),n&&f){let s={...C,chargeData:{...C?.chargeData,cardData:n?.data}};f&&!I&&(R(true),f?.(s).then(a=>{if(a?.adyenActionFor3DSecure){let S=a?.extraData?.metadata;g({actualId:S.actualId,historyId:S.historyId,bookingFrom:S.bookingFrom}),removeBeforeUnloadListener(),h==="paypal"?T?.createFromAction(a?.adyenActionFor3DSecure).mount(p.current):o?.resolve(a?.extraData?.rawResponse);return}a?.status==="success"?k(a):(o?.reject({}),r?.({errors:[u($.problemWithCard)]}));}).catch(a=>{r?.({errors:[y||""]});}));}return async({data:s,submitBookReservation:a,onSuccessfulBooking:S,onFailure:N})=>{try{F(s),l(()=>a),i(()=>S),D(()=>N),h==="paypal"?(c?.setStatus("paymentPending"),_({data:{paymentMethod:{type:h}}})):c?.submit();}catch(W){N&&(window.history.go(-1),N(W));}}}export{Fe as a,dt as b,_t as c};